import React from "react";
import PropTypes from 'prop-types';

ResolutionLink.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string
}

export function ResolutionLink(props) {
  return (
    <a href={props.url} target="_blank" rel="noopener noreferrer" className="support-form-resolution-link">
      <div className="support-form-resolution-link__text">{props.name}</div>
      <div className="support-form-resolution-link__icon mask-square-arrow-up-right"/>
    </a>
  );
}
